import { render, staticRenderFns } from "./ISmallButton.vue?vue&type=template&id=176292c8&scoped=true&"
import script from "./ISmallButton.vue?vue&type=script&lang=js&"
export * from "./ISmallButton.vue?vue&type=script&lang=js&"
import style0 from "./ISmallButton.vue?vue&type=style&index=0&id=176292c8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176292c8",
  null
  
)

export default component.exports